import { render, staticRenderFns } from "./ArticleEditor.vue?vue&type=template&id=45739256&"
import script from "./ArticleEditor.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ArticleEditor.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports